import * as Sentry from '@sentry/react';

const UPDATE_CHECK_INTERVAL_MS = 60_000;

const getMainScriptSrc = (doc: Document): string | null =>
  doc.querySelector<HTMLScriptElement>('script[src*="/static/js/main."]')?.getAttribute('src') ?? null;

export const initCacheBuster = (): void => {
  const currentScriptSrc = getMainScriptSrc(document);
  if (!currentScriptSrc) return;

  setInterval(async () => {
    if (!navigator.onLine) return;

    try {
      const response = await fetch('/index.html', {
        cache: 'no-store',
        headers: { 'cache-control': 'no-cache' },
      });
      if (response.status !== 200) return;

      const html = await response.text();
      const latestScriptSrc = getMainScriptSrc(new DOMParser().parseFromString(html, 'text/html'));

      if (latestScriptSrc && latestScriptSrc !== currentScriptSrc) {
        window.location.reload();
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  }, UPDATE_CHECK_INTERVAL_MS);
};
